import React, { useEffect, useState } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { postWelcome } from '../../api/login'
import { useMyContext } from '../../components/provider/MyProvider'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { imgURL } from '../Footer'
import { useAppContext } from '../provider/AppProvider'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

/**
 * 모달 팝업 - 섬 모양
 *
 * @params content - 콘텐츠 내용
 */

export default function WelcomeModal({
  setWelcomeModal,
}: {
  setWelcomeModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()
  const { isAppView } = useAppContext()
  const navigate: NavigateFunction = useNavigate()

  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setWelcomeModal(false)
      setClosing(false)
    }, 280)
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalBody>
          <div className='welcome_gift_wrap'>
            <div className='welcome_contents'>
              <h3>
                웰컴 기프트가
                <br /> 도착했어요!
              </h3>
              <div className='coin_img'>
                <img src={`${imgURL}/img_coin.png`} alt='코인 이미지' />
              </div>
              <p className='point'>
                적립금 30,000
                <img src={`${imgURL}/icon_point.png`} alt='won' />
              </p>
              <p className='sub_txt'>한 번 뿐인 웰컴 기프트를 받아보세요!</p>
            </div>
            <div className='button_area'>
              <button
                className='black'
                onClick={() => {
                  closeModal()
                  postWelcome().then(() => {
                    setIsToast(true)
                    setToastMessage('적립금 30,000원이 지급되었습니다.')
                    setToastBtnMessage('바로가기')
                    setToastEvent(() => () => {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/accumulation`,
                        })
                      } else {
                        navigate('/accumulation')
                      }
                    })
                  })
                }}
              >
                적립금 받기
              </button>
              <button
                onClick={() => {
                  setIsToast(true)
                  setToastMessage('적립금 30,000원이 지급되었습니다.')
                  setToastBtnMessage('바로가기')
                  setToastEvent(() => () => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/accumulation`,
                      })
                    } else {
                      navigate('/accumulation')
                    }
                  })
                  closeModal()
                  postWelcome().then(() => {
                    setIsToast(true)
                    setToastMessage('적립금 30,000원이 지급되었습니다.')
                    setToastBtnMessage('바로가기')
                    setToastEvent(() => () => {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/accumulation`,
                        })
                      } else {
                        navigate('/accumulation')
                      }
                    })
                  })
                  window.sessionStorage.setItem('welcomeGiveup', JSON.stringify(true))
                }}
              >
                닫기
              </button>
            </div>
          </div>
        </ModalBody>
      </ModalBox>
      <ModalBackground
        onClick={() => {
          closeModal()
          setIsToast(true)
          setToastMessage('적립금 30,000원이 지급되었습니다.')
          setToastBtnMessage('바로가기')
          setToastEvent(() => () => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/accumulation`,
              })
            } else {
              navigate('/accumulation')
            }
          })
          window.sessionStorage.setItem('welcomeGiveup', JSON.stringify(true))
        }}
        closing={closing}
      ></ModalBackground>
    </ModalWrap>
  )
}

interface typeProps {
  closing?: boolean
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
  z-index: 20;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
`

export const ModalBox = styled.div<typeProps>`
  width: calc(100% - 40px);
  background-color: var(--colWhite);
  padding: 0 20px 20px;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: fixed;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 10px;
  @media screen and (min-width: 768px) {
    width: 353px;
    animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
  }
`

export const ModalBody = styled.div``

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`
